export class TokenCertificateParameters {
  httpFrom = 9000;
  httpTo = 9010;
  httpsFrom = 10000;
  httpsTo = 10010;

  constructor() {
  }
}
